/**
 * Comprueba si la suscripción actual tiene un entitlement activo.
 * Misma regla que EntitlementPageGuard (sin wildcard GRANTED).
 *
 * @param {object|null|undefined} subscriptionState
 * @param {string} featureName - constante en `constants/entitlements`
 * @returns {boolean}
 */
export const subscriptionHasEnabledFeature = (
  subscriptionState,
  featureName,
) => {
  if (!subscriptionState || !featureName) return false
  const list = subscriptionState.subscription_entitlements
  if (!Array.isArray(list)) return false
  return list.some(
    ent => ent.feature_name === featureName && ent.is_enabled === true,
  )
}
